import { render, staticRenderFns } from "./emailseventos.vue?vue&type=template&id=736f11fd"
import script from "./emailseventos.vue?vue&type=script&lang=js"
export * from "./emailseventos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports